import React, { useState, useEffect, useRef } from 'react';

export default function SearchableSelect({ options, value, onChange, placeholder, disabled }) {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const wrapperRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedOption = options.find((opt) => String(opt.value) === String(value));
    const filteredOptions = options.filter((opt) =>
        opt.label.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div ref={wrapperRef} className="relative w-full sm:w-64">
            <div
                className={`bg-gray-800 border border-gray-700 rounded px-4 py-2.5 text-white cursor-pointer min-h-[42px] flex items-center justify-between transition-colors ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:border-gray-500'}`}
                onClick={() => { if (!disabled) setIsOpen(!isOpen); }}
            >
                <span className="truncate">{selectedOption ? selectedOption.label : placeholder}</span>
                <svg className="w-4 h-4 text-gray-400 ml-2 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4" /></svg>
            </div>

            {isOpen && (
                <div className="absolute z-[1000] w-full mt-1 bg-gray-800 border border-gray-700 rounded shadow-xl shadow-black/50 max-h-60 flex flex-col overflow-hidden">
                    <div className="bg-gray-800 p-2 border-b border-gray-700 shrink-0">
                        <input
                            type="text"
                            className="w-full bg-gray-900 border border-gray-700 rounded px-3 py-1.5 text-white text-sm focus:outline-none focus:border-blue-500"
                            placeholder="Search..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            autoFocus
                        />
                    </div>
                    <div className="overflow-y-auto">
                        <div
                            className={`px-4 py-2.5 cursor-pointer text-sm text-gray-300 hover:bg-blue-600 hover:text-white transition-colors ${value === '' ? 'bg-blue-600 outline-none text-white' : ''}`}
                            onClick={() => { onChange(''); setIsOpen(false); setSearch(''); }}
                        >
                            {placeholder}
                        </div>
                        {filteredOptions.length === 0 ? (
                            <div className="px-4 py-3 text-sm text-gray-500 text-center">No results found</div>
                        ) : (
                            filteredOptions.map((opt) => (
                                <div
                                    key={opt.value}
                                    className={`px-4 py-2.5 cursor-pointer text-sm truncate hover:bg-blue-600 hover:text-white transition-colors ${String(opt.value) === String(value) ? 'bg-blue-600 outline-none text-white' : 'text-gray-300'}`}
                                    onClick={() => { onChange(opt.value); setIsOpen(false); setSearch(''); }}
                                >
                                    {opt.label}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
